import React from 'react';
import { Box, Typography, Button, CardMedia, Container } from '@mui/material';
import styles from './MarketingPage.module.scss';

const MarketingPage = ({ imageUrl, imageAlt, heading, description, buttonLink, buttonText }) => (
    <Box className={styles.pageBox}>
        <Container className={styles.marketingContainer}>
            <Box display="flex" justifyContent="center">
                <CardMedia
                    component="img"
                    image={imageUrl}
                    alt={imageAlt}
                    className={styles.cardImage}
                />
            </Box>
            <Box height={32} aria-hidden="true" />
            <Typography
                variant="h4"
                className={styles.headingText}
                gutterBottom
            >
                {heading}
            </Typography>
            <Typography className={styles.descriptionText}>
                {description}
            </Typography>
            <Box className={styles.marketingButtonContainer}>
                <Button
                    variant="contained"
                    href={buttonLink}
                    target="_blank"
                    className={styles.marketingButton}
                >
                    {buttonText}
                </Button>
            </Box>
        </Container>
    </Box>
);

export default MarketingPage;
